export const ORDER_STATUS_REFUNDED = "REFUNDED";
export const ORDER_STATUS_COMPLETED = "COMPLETED";
export const ORDER_STATUS_NOT_COMPLETED = "NOT_COMPLETED";